import { createRef } from '@wix/materializer'
import type { Ref } from '@wix/thunderbolt-types'
import { InternalRefDataItem, pointers, ViewMode, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { getRefTemplateKey, isRefComponent, isSharedPart as isSharedPartUtil } from '../../byRefUtils'
import { createByRefsisTemplateCompNode } from '../../compNodeUtils'
import { ENVIRONMENT_NAMESPACE, SITE_NAMESPACE } from '../../constants'

type Dependencies =
	| {
			refCompData: Ref<WidgetRefDataItem | InternalRefDataItem>
			viewMode: Ref<ViewMode>
	  }
	| undefined
type ViewItem = { templateKey: string; rootCompId: string; isSharedPart: boolean; pageId?: string } | null

const {
	data: {
		DATA_MAPS: { DATA },
	},
} = pointers

export const RefComponentsTemplateData = createByRefsisTemplateCompNode<Dependencies, ViewItem>({
	getDependencies: (__, component, scopedCreateRef) =>
		isRefComponent(component)
			? {
					refCompData: scopedCreateRef(DATA, removeHash(component.dataQuery!)) as Ref<WidgetRefDataItem>,
					viewMode: createRef<ViewMode>([ENVIRONMENT_NAMESPACE, ENVIRONMENT_NAMESPACE, 'viewMode']),
			  }
			: undefined,
	toViewItem: (__, dependencies) => {
		if (!dependencies) {
			return null
		}

		const { refCompData, viewMode } = dependencies
		const { rootCompId, pageId } = refCompData as InternalRefDataItem

		// Once DM migrates to use internalBlocksRef, we will have distinction between editor internalRefs and blocks internalRefs, and then we won't need to check isSharedPart (every internalRef will be shared part)
		// This will be possible only once blocks finish migrating all existing internalRefs to the new type, so when merging this experiment after migration, we can remove shared part check and just assume internalRef is sharedPart.
		const isInternalRef = refCompData.type === 'InternalRef' || refCompData.type === 'InternalBlocksRef'

		const isSharedPart = isInternalRef && isSharedPartUtil(refCompData as InternalRefDataItem)
		const templateKey = isInternalRef ? SITE_NAMESPACE : getRefTemplateKey(refCompData, viewMode)

		return {
			templateKey,
			isSharedPart,
			rootCompId,
			pageId: isSharedPart ? 'masterPage' : pageId,
		}
	},
})
